import React from 'react';
import PropTypes from 'prop-types';

import { appConfig, lang } from '../services';

import Logo from './Logo';

const Footer = ({
    onClickAgreement = (f) => f,
}) => {
    return (
        <div className="Footer">
            <div className="Footer__logo">
                <Logo />
            </div>
            <div className="Footer__body">
                <div className="Footer__row">
                    {lang.t('Thanks for using {PROXYNAME}', {
                        PROXYNAME: appConfig.defines.SITE_NAME
                    })}
                </div>
                <div className="Footer__row Footer__rowContact">
                    <div className="Footer__contact">
                        {lang.t('Need help? Contact us:')}&nbsp;
                    </div>
                    <div className="Footer__email Footer__marked">
                        <a
                            className='Footer__marked-link'
                            href={`mailto:${appConfig.defines.SUPPORT_EMAIL}`}
                        >
                            {appConfig.defines.SUPPORT_EMAIL}
                        </a>
                    </div>
                </div>
                <div className="Footer__row Footer__marked">
                    <span
                        className='Footer__click-text'
                        onClick={onClickAgreement}  
                        rel='noreferrer'
                    >
                        {lang.t('User agreement')}
                    </span>
                </div>
            </div>
        </div>
    )
};

Footer.propTypes = {
    onClickAgreement: PropTypes.func,
}

export default Footer;